












































































































import { Vue, Component } from "vue-property-decorator";
import { Field, Cell, CellGroup, Popup, Picker, DatetimePicker, Switch, Card, Dialog } from "vant";
import roleUtils from "@/utils/roleUtils";
import dataShare from "../dataShare";
import { RoleInfoEntity, CardInfoEntity, ContactInfoEntity } from "../../../model/system";
import { CardType, Categorys, categoryMap, CategoryInfoEntity } from "../../../model/Base";
import baseService from "@/service/baseService";
import _ from "lodash";
import moment from "moment";

var model2 = {
  editRole: {
    ContactInfo: {
      ContactID: "S00008447832",
      RoleID: "S00008447832",
      ContactPeople: "",
      ContactPhone: "18337466496",
      ContactEmail: "lcsltest@163.com",
      CreateUserID: "",
      CreateUserName: "",
      UpdateUserID: "",
      UpdateUserName: "",
    },
    Cards: [
      {
        CardID: "S00008492139",
        CardType: 1138,
        CardNo: "140105199403070070",
        IssueDate: "2019-07-16T18:44:48.663",
        ExpireDate: "2029-11-30T00:00:00",
        IssueCountry: 151,
        RoleNick: "",
        RoleName: "",
        EnglishFirstName: "",
        EnglishLastName: "",
        isActive: false,
      },
    ],
    RoleID: "S00008447832",
    RoleName: "",
    RoleNick: "",
    RoleType: 1311,
    RoleIcon: "https://storage.lchtrip.com/api/storage/download/image/20191227/1577427037.png",
    RoleGenre: 1145,
    BirthDate: "1990-01-01",
    ContactID: "S00008447832",
    FirstName: "ZHANG",
    LastName: "SAN",
    RoleIntro: "",
    lang: "cn",
  },
};
let CountryCode=''
@Component({
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [DatetimePicker.name]: DatetimePicker,
    [Switch.name]: Switch,
  },
  filters: {},
})
export default class extends Vue {
  passport = CardType.PassportCard;
  ServiceType=dataShare.ServiceType;
  minExpireDate = new Date();

  minDate = new Date(1920, 0, 1);
  maxDate = new Date();

  getGenre(val?: any) {
    let Genres = [
      { code: 1145, text: this.$root.$t("mall_modules_editrole_nan") as string },
      { code: 1146, text: this.$root.$t("mall_modules_editrole_nv") as string },
    ];
    let Genre: any = _.find(Genres, item => {
      return item.code == val;
    });
    return (Genre || Genres[0]).text;
  }

  get ExpireDate(): Date {
    return (this as any).$moment(this.card.ExpireDate as any).toDate();
  }
  set ExpireDate(value: Date) {
    this.card.ExpireDate = (this as any).$moment(value).format("YYYY-MM-DD");
  }
  get ExpireDateText() {
    return (this as any).$moment(this.card.ExpireDate as any).format("YYYY-MM-DD");
  }
  // get isOneSelf() {
  //   return this.$route.query.isOneSelf == 'true';
  // }

  // get currentDate(): Date {
  //   return (this as any).$moment(this.role.BirthDate as any).toDate();
  // }
  get isReadOnly() {
    return this.$route.query.isReadOnly == 'true';
  }
  get BirthDate() {
    return (this as any).$moment(this.role.BirthDate as any).toDate();
    // return (this as any).$moment(this.role.BirthDate as any).format("YYYY-MM-DD");
  }
  get BirthDateText() {
    // return (this as any).$moment(this.role.BirthDate as any).toDate();
    return (this as any).$moment(this.role.BirthDate as any).format("YYYY-MM-DD");
  }
  set BirthDate(value: Date) {
    this.role.BirthDate = (this as any).$moment(value).format("YYYY-MM-DD");
  }
  showCardType = false;
  showGenre = false;
  showCountry = false;
  showPicker = false;
  showExpirePicker = false;

  Genres = [this.$root.$t("mall_modules_editrole_nan") as string, this.$root.$t("mall_modules_editrole_nv") as string];

  chinaCountry: any = {};

  CountryNames: any[] = [this.$root.$t("mall_modules_editrole_zhongguo") as string];
  get defaultCountry() {
    return _.findIndex(this.CountryNames, item => item == this.chinaCountry.CountryName);
  }

  get cardName() {
    return this.columns.filter((o: any) => o.value == this.card.CardType)[0].text;
  }

  columns = roleUtils.BuildCardTypes();

  beforeMount() {
    var editRole = this.role as any;
    if (!editRole.Cards || editRole.Cards.length == 0) {
      editRole.Cards = [roleUtils.BuildCard(CardType.IDCard)];
    }
    var active = _.find(editRole.Cards, (o: any) => o.isActive);
    if (!active) {
      active = editRole.Cards[0];
      active.isActive = true;
    }

    let role = this.role as any;
    if (active.value == CardType.PassportCard) {
      this.$set(role, "lang", "en");
    } else {
      this.$set(role, "lang", "cn");
    }
    if (role.RoleName && !active.RoleName) {
      active.RoleName = role.RoleName;
    }
    if (role.FirstName && !active.EnglishFirstName) {
      active.EnglishFirstName = role.FirstName;
    }
    if (role.LastName && !active.EnglishLastName) {
      active.EnglishLastName = role.LastName;
    }
  }
  mounted() {
    this.getCountryDatas();
  }

  dataShare = dataShare;


  role = _.cloneDeep(dataShare.editRole) as RoleInfoEntity;

  get contact(): ContactInfoEntity {
    return (this.role as any).ContactInfo;
  }
  get card(): CardInfoEntity {
    if (!this.role) {
      return new CardInfoEntity();
    }
    return (this.role as any).Cards.filter((o: any) => o.isActive)[0];
  }

  onCardSelected(selected: any) {
    this.dataShare.selected=selected.value
    this.showCardType = false;
    let cards = (this.role as any).Cards;

    cards.forEach((card: any) => (card.isActive = false));

    let active = cards.filter((o: any) => o.CardType == selected.value)[0];
    if (!active || active.length == 0) {
      active = roleUtils.BuildCard(selected.value) as any;
      cards.push(active);
    }
    active.isActive = true;
    let role = this.role as any;
    if (selected.value == CardType.PassportCard) {
      role.lang = "en";
    } else {
      role.lang = "cn";
    }
    if (role.RoleName && !active.RoleName) {
      active.RoleName = role.RoleName;
    }
    if (role.FirstName && !active.EnglishFirstName) {
      active.EnglishFirstName = role.FirstName;
    }
    if (role.LastName && !active.EnglishLastName) {
      active.EnglishLastName = role.LastName;
    }
    if (selected.value==1138 || selected.value==1141||selected.value==1234||selected.value==1233||selected.value==1140){
      this.role.Country=151
      this.getCountryName(this.role.Country)
    }else if (selected.value==1299){
      this.role.Country=134
      this.getCountryName(this.role.Country)
    } else {
      this.role.Country=undefined
      this.getCountryName(this.role.Country)
    }
  }
  onCountrySelected(selected: any) {
    this.showCountry = false;
    let Country = _.find(this.CountryDatas, item => item.CountryName == selected);
    this.role.Country = Country.ZoneID;
  }

  onGenreSelected(selected: any) {
    this.showGenre = false;
    if (selected == (this.$root.$t("mall_modules_editrole_nan") as string)) {
      this.role.RoleGenre = 1145;
      return;
    }
    this.role.RoleGenre = 1146;
  }
  onConfirm1(time: string) {
    this.role.BirthDate = (this as any).$moment(time).format("YYYY-MM-DD");
    this.showPicker = false;
  }
  onConfirmExpire(time: string) {
    this.card.ExpireDate = (this as any).$moment(time).format("YYYY-MM-DD");
    this.showExpirePicker = false;
  }

  CountryDatas: any[] = [];
  getCountryDatas() {
    let data = { ZoneType: "1442", PageSize: 999999 };
    baseService.getZoneList(data).then(res => {
      if (res.isSucc) {
        this.CountryDatas = res.result.entities;
        this.CountryNames = _.map(res.result.entities, item => item.CountryName);
        this.chinaCountry = _.find(res.result.entities, o => o.CountryID == 151);
      }
    });
  }
  getCountryName(val?: any) {
    if (val==='')return
    let Country: any = _.find(this.CountryDatas, item => item.ZoneID == val);
    CountryCode=Country==undefined? Country: Country.ZoneCode

    return Country && Country.CountryName;
  }
  handleBlur() {
    if (this.card.CardType == CardType.IDCard && this.card.CardNo && this.card.CardNo.length >= 18) {
      this.role.BirthDate = (this as any).$moment(this.card.CardNo!.substr(6, 8)).format("YYYY-MM-DD");
    }
  }
  save() {
    let role = this.role as any;
    const nameRegex = /^(\s|\d)*$/;
    if (role.lang == "en") {
      if (nameRegex.test(this.card.EnglishFirstName!) || nameRegex.test(this.card.EnglishLastName!)) {
        return Dialog.alert({ message: "必须填写旅客名称" });
      }
    } else {
      if (nameRegex.test(this.card.RoleName!)) {
        return Dialog.alert({ message: "必须填写旅客名称" });
      }
    }
    if (role.Country===undefined &&  this.ServiceType!="1407"){
      return Dialog.alert({ message: "必须填写国籍" });
    }
    if (role.Country===undefined &&  this.ServiceType=="1407"){
      role.Country=151
    }
    let cardType = this.card.CardType as CardType.IDCard | CardType.PassportCard | CardType.ForeignResidentIDCard | CardType.Residencebooklet | CardType.birthcertificate;
    let cardNo = this.card.CardNo;
    let rule = roleUtils.CardRule()[cardType!];
    // if (rule && (!cardNo || !rule.test(cardNo))) {
    //   return Dialog.alert({ message: "证件号格式错误" });
    // }
    if (cardNo=='' &&  this.ServiceType!="1407") {
      return Dialog.alert({ message: "证件号格式错误" });
    }
    let birthDate = this.BirthDateText;
    if (cardType == CardType.IDCard && cardNo!.indexOf(birthDate.replaceAll("-", "")) < 5 &&  this.ServiceType!="1407") {
      return Dialog.alert({ message: "出生日期与证件不符" });
    }
    let contactPhone = this.contact.ContactPhone;
    if (!contactPhone || !/^\d{11}$/.test(contactPhone)) {
      return Dialog.alert({ message: "请填写正确的手机号" });
    }

    if (cardType == CardType.Residencebooklet || cardType == CardType.birthcertificate) {
      if (moment(this.role.BirthDate).isBefore(moment().add(-16, "year"))) {
        let name = "户口簿";
        if (cardType == CardType.birthcertificate) {
          name = "出生证明";
        }
        return Dialog.alert({ message: `年龄大于16周岁，不可使用${name}，请选择成人有效证件` });
      }
    }
    if (moment(this.role.BirthDate).isAfter(moment().add(-6, "year"))) {
      return Dialog.alert({ message: `系统暂不支持6岁以下儿童及婴儿机票预定，如有需要请联系客服！` });
    }
    if (moment(this.role.BirthDate).isBefore(moment().add(-90, "year"))) {
      return Dialog.alert({ message: `系统暂不支持90岁以上旅客机票预定，如有需要请联系客服！` });
    }
    Object.assign(this.dataShare.editRole, this.role);
    this.dataShare.editRole.CountryCode=CountryCode
    console.log(this.dataShare,this.role,'-=-=this.dataShare')
    this.back();
  }
  back() {
    history.back();
  }
}
